import {NavController, LoadingController, AlertController, Events, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from "../../services/user.services";
import {AppConfigService} from "../../services/appConfig.service";
import {HomePage} from "../home/home";
import {AppDialog} from "../../component/appDialog";
import {WithdrawListPage} from "../withdrawList/withdrawList";
import { CommonService } from "../../services/common.service";
import {LotteryService} from "../../services/lottery.services";

@Component({
    templateUrl: 'withDrawal.html',
    selector: 'with-drawal-page',
})
export class WithDrawalPage {
    selectAction: string = "action1";
    bankList: any = [];
    //充值编号
    cardid: string;
    wamount: string = '';
    balance: any = "0";
    checkpwd: string;
    wmin: number;
    wmax: number;
    //最大提取次数
    mrtxcs: number;
    //已经提取次数
    wtimes: number;
    //提款有效时间
    wdhours: number;
    stime: string;
    etime: string;
    eid: string;

    constructor(private keyboard: Keyboard, private nav: NavController, public events: Events, private userService: UserService, private lotteryService: LotteryService,
                private alertCtrl: AlertController, public loadingCtrl: LoadingController, private cs: CommonService) {
        this.initService();
    }

    initService() {
        this.userService.withdrawal(undefined, this.alertCtrl).then(data => {
            this.bankList = data["wlist"];
            this.wmin = data["wmin"];
            this.wmax = data["wmax"];
            this.mrtxcs = data["mrtxcs"];
            this.wtimes = data["wtimes"];
            this.wdhours = data["wdhours"];
            if (this.bankList.length > 0) {
                this.cardid = this.bankList[0].id;
            }
            if (data["msg"] !== '') {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
        this.userService.WithdrawalSearchInit(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.stime = data["stime"].replace(" ", "T");
                this.etime = data["etime"].replace(" ", "T");
            }
        });
        this.formatCurrency();
    }

    submitFn() {
        if (this.mrtxcs == this.wtimes) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Vượt quá số lượt rút tiền trong ngày"
            });
            return;
        }
        let postData = {
            checkpwd: this.checkpwd,
            wamount: this.wamount.replace(/[,]/g, ''),
            cardid: this.cardid
        };
        this.userService.withdrawalApply(postData, this).then(data => {
            if (!data["msg"]) {
                this.balance = this.cs.numberWithCommas(Number(this.balance.replace(/[,]/g, '')) - Number(this.wamount.replace(/[,]/g, '')));
                this.mrtxcs = data["mrtxcs"];
                this.wtimes = data["wtimes"];
                this.wdhours = data["wdhours"];
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Gửi yêu cầu rút tiền thành công"
                });
                this.wamount = null;
                this.checkpwd = "";
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                })
            }
        });
    }

    searchFn() {
        let requestData: any = {
            stime: this.stime.replace("T", " ").substr(0, 19),
            etime: this.etime.replace("T", " ").substr(0, 19),
            id: this.eid
        };

        this.userService.WithdrawalSearch(requestData, this).then(data => {
            if (!data["msg"]) {
                this.nav.push(WithdrawListPage, {
                    requestData: requestData,
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }

    ionViewWillEnter() {
        this.lotteryService.getBalance( data => {
            this.balance = this.cs.numberWithCommas(data["balance"]);
        });
    }

    formatCurrency() {
        let amount: any = this.wamount.replace(/[,.]/g, '');
        if (isNaN(amount)) {
            amount = 0;
        }
        this.wamount = this.cs.numberWithCommas(Number(amount));
    }
}



// WEBPACK FOOTER //
// ./src/pages/withDrawal/withDrawal.ts